import { createFileRoute } from "@tanstack/react-router";
import { MAPA_META, pickMeta } from "@/lib/page-meta";
import { MapaPublicPage } from "@/routes/mapa";

export const Route = createFileRoute("/mapa-verejna")({
  ssr: false,
  component: MapaPublicPage,
  validateSearch: (search: Record<string, unknown>): { kind?: string; lang?: string } => ({
    kind: typeof search.kind === "string" ? search.kind : undefined,
    lang: typeof search.lang === "string" ? search.lang : undefined,
  }),
  head: ({ match }) => {
    const m = pickMeta(MAPA_META, (match.search as { lang?: string }).lang);
    const url = "https://cerveza.international/mapa-verejna";
    const title = `${m.title} — veřejná verze`;
    return {
      meta: [
        { title },
        { name: "description", content: m.description },
        { property: "og:title", content: title },
        { property: "og:description", content: m.description },
        { property: "og:url", content: url },
        { property: "og:type", content: "website" },
      ],
      links: [{ rel: "canonical", href: url }],
    };
  },
});
